module.exports = __webpack_public_path__ + "img/warning-red.1605e771.png";